import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {WalkThroughTooltipComponent} from './walkthrough-tooltip/walkthrough-tooltip.component';
import {ButtonModule} from '../../components/dumb/button/button.module';
import {WalkThroughStepDirective} from './walkthough-step/walkthrough-step.directive';
import {A11yModule} from '@angular/cdk/a11y';

@NgModule({
  declarations: [WalkThroughTooltipComponent, WalkThroughStepDirective],
  imports: [CommonModule, MatProgressBarModule, ButtonModule, MatIconModule, A11yModule],
  exports: [WalkThroughTooltipComponent, WalkThroughStepDirective],
})
export class WalkThroughModule {}
